<template>
  <div
    v-show="hasContent"
    :class="[
      'fieldset',
      dense === true ? 'fieldset--dense' : null,
    ]"
  >
    <div
      v-show="label || description"
      class="fieldset__header"
      :class="headerClass"
    >
      <h3 class="fieldset__label">
        {{ label }}
      </h3>
      <InputfieldDescription
        :text="description"
        class="fieldset__description"
      >
        <slot name="description" />
      </InputfieldDescription>
    </div>
    <div
      class="fieldset__content"
      :class="contentClass"
    >
      <slot />
    </div>
    <div
      v-show="notes"
      class="fieldset__footer"
    >
      <InputfieldNotes :text="notes" />
    </div>
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'

export default {
  name: 'InputfieldFieldset',
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldDescription,
    InputfieldNotes,
  },
  props: {
    name: {
      type: String,
      required: false,
      default () {
        return null
      },
    },
    label: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    headerClass: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    contentClass: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    dense: {
      type: [Boolean],
      required: false,
      default () {
        return false
      },
    },
  },
  computed: {
    hasContent () {
      return !!this.$slots.default
    },
  },
}

</script>

<style lang="scss">

</style>
